module.exports = __webpack_public_path__ + "img/Download_1.08b8380f.svg";